import React from "react";

export function BotAvatar(): React.ReactElement {
  return (
    <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-500">
      <svg width={12} height={12} viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    </div>
  );
}
